const getVisibleClientFields = require('../visible-client-fields');

const fieldVisibility = {
  topRow: true,
  bottomRow: true,
  columnButtonRow: true,
  searchRow: true,
  brandName: {
    other: true,
    spsc: true,
    nswh: true
  },
  manufacturer: {
    other: true,
    nswh: true,
    spsc: true
  },
  type: {
    nswh: true,
    other: true
  },
  subType: {
    nswh: true,
    other: true
  },
  productName: {
    nswh: true,
    other: true
  },
  deviceType: {
    nswh: true,
    other: true
  },
  quantityUsed: {
    nswh: true,
    other: true
  },
  batchNumber: {
    nswh: true,
    other: true
  },
  expiryDate: {
    nswh: true,
    other: true
  },
  dateManufactured: {
    nswh: true,
    other: true
  },
  catalogueNumber: {
    nswh: true,
    other: true
  },
  operator: {
    nswh: true,
    other: true
  },
  usage: {
    nswh: true,
    other: true
  },
  currentLocationOfDevice: {
    nswh: true,
    other: true
  },
  serialNumber: true,
  model: true,
  supplier: {
    spsc: true
  },
  supplyCategory: {
    spsc: true
  },
  supplyClassification: {
    spsc: true
  },
  sourceId: true,
};

function getVisibleClientFieldsWrapper() {
  return getVisibleClientFields(fieldVisibility);
}

module.exports = getVisibleClientFieldsWrapper;
